/**
 * PermissaoTemplate — template CRUD da entidade Permissão.
 *
 * Permissões representam ações individuais de controller/action do Sails.
 * O campo `tipo` diferencia permissões de entidade (CRUD) de processos (ações customizadas).
 * O campo `state` é a chave i18n que identifica a permissão na interface.
 */
import React, { Component } from 'react';

import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import Permissao from '../../../models/Permissao';
import PermissaoTipo from '../../../enums/PermissaoTipo';

// ─── Esquema de campos ────────────────────────────────────────────────────────

const model = {
    controller: {
        exibir: 'main.permissao.controller',
        visivel: true,
        validacao: { obrigatorio: true }
    },
    action: {
        exibir: 'main.permissao.action',
        visivel: true,
        validacao: { obrigatorio: true }
    },
    tipo: {
        exibir: 'main.permissao.tipo',
        visivel: true,
        tipo: 'enum',
        entidade: 'tipo.entidade',
        validacao: { obrigatorio: true }
    },
    state: {
        exibir: 'main.permissao.state',
        visivel: true,
    },
};

// ─── Renderers customizados ───────────────────────────────────────────────────

const renderers = {
    tipo: { entidade: PermissaoTipo },
};

// ─── Formulário de campos (render prop) ───────────────────────────────────────

class PermissaoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        return (
            <>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.controller} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.action} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelDropDown model={model.tipo} contexto={contexto} />
                </div>
                <div className="field col-12 md:col-6 mt-3">
                    <ModelTextInput model={model.state} contexto={contexto} />
                </div>
            </>
        );
    }
}

// ─── Template (componente exportado) ─────────────────────────────────────────

class PermissaoTemplate extends Component {

    render() {
        return (
            <EntityGrid
                entidade={Permissao}
                model={model}
                identidade="main.permissao"
                icone="pi-lock"
                permissoes={this.props.permissoes}
                storageKey="dt-permissoes"
                ocultarColunaPublicacao // catalogo global (naofiltrarpublicacao:true no model backend)
                processos={[]}
                relacionados={[]}
                renderers={renderers}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                formulario={(m, ctx) => <PermissaoFormulario model={m} contexto={ctx} />}
            />
        );
    }
}

export default PermissaoTemplate;
